import React from 'react';
import { MantineReactTable } from 'mantine-react-table';


const CustomMantineTable = ({ columns, data, loading, ...rest }) => {
  return (
    <MantineReactTable
      columns={columns}
      data={data}
      state={{ isLoading: loading }}
      enableTableScroll
      mantineTableProps={{
        verticalSpacing: 'xs', // Options: 'xs', 'sm', 'md', etc.
      }}
      mantineTableHeadCellProps={{
        style: { padding: '2px 8px' }, // Adjust these values as needed
      }}
      mantineTableBodyCellProps={{
        style: { padding: '6px 8px' },
      }}
      {...rest}
    />
  );
};

export default CustomMantineTable;



// import React, { useState } from 'react';
// import { MantineReactTable } from 'mantine-react-table';

// const CustomMantineTable = ({ columns, data, loading, ...rest }) => {
//   // Load column order from localStorage. If not set, default to the order of accessorKey values from columns.
//   const savedOrder = localStorage.getItem('customColumnOrder');
//   const initialOrder = savedOrder ? JSON.parse(savedOrder) : columns.map(col => col.accessorKey);

//   const [columnOrder, setColumnOrder] = useState(initialOrder);

//   // Update the column order state and persist it in localStorage
//   const handleColumnOrderChange = (newOrder) => {
//     setColumnOrder(newOrder);
//     localStorage.setItem('customColumnOrder', JSON.stringify(newOrder));
//   };

//   return (
//     <MantineReactTable
//       columns={columns}
//       data={data}
//       state={{ isLoading: loading }}
//       enableTableScroll
//       enableColumnOrdering
//       columnOrder={columnOrder}
//       onColumnOrderChange={handleColumnOrderChange}
//       mantineTableProps={{
//         verticalSpacing: 'xs', // Options: 'xs', 'sm', 'md', etc.
//       }}
//       mantineTableHeadCellProps={{
//         style: { padding: '2px 8px' }, // Adjust these values as needed
//       }}
//       mantineTableBodyCellProps={{
//         style: { padding: '6px 8px' },
//       }}
//       {...rest}
//     />
//   );
// };

// export default CustomMantineTable;
